import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { trackByValue } from 'v2/modules/shared/util/track-by.util';

@Component({
  selector: 'lum-alternate-ids',
  templateUrl: './alternate-ids.component.html',
  styleUrls: ['./alternate-ids.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatChipsModule,
    MatIconModule,
    RouterModule
  ]
})
export class AlternateIdsComponent implements OnChanges {
  @Input() formArray: UntypedFormArray;
  @Input() label: string = 'Alternate IDs';
  @Input() placeholder: string = 'Add alternate ID...';
  @Input() readonly: boolean = false;
  @Input() showAsChips: boolean = false;
  @Input() routerLink: string[] = ['/orders'];
  @Input() queryParamKey: string = 'alternateIds';

  @Output() alternateIdAdded = new EventEmitter<string>();
  @Output() alternateIdRemoved = new EventEmitter<string>();

  separatorKeysCodes: number[] = [ENTER, COMMA];
  alternateIdsCtrl = new UntypedFormControl();
  trackByValue = trackByValue;
  queryParams: { [key: string]: string } | null = null;

  constructor(private fb: UntypedFormBuilder) {}

  ngOnChanges({ showAsChips, queryParamKey } :SimpleChanges): void {
    if (showAsChips || queryParamKey) {
      this.updateQueryParams();
    }
  }

  private updateQueryParams() {
    if (this.showAsChips && this.formArray?.value?.length > 0) {
      this.queryParams = { [this.queryParamKey]: this.formArray.value[0] };
    } else {
      this.queryParams = null;
    }
  }

  onAddAlternateId(event: any): void {
    const value = (event.value || '').trim();
    if (value) {
      this.formArray.push(this.fb.control(value));
      this.alternateIdAdded.emit(value);
      this.updateQueryParams();
    }
    event.chipInput!.clear();
    this.alternateIdsCtrl.setValue(null);
  }

  onRemoveAlternateId(alternateId: string): void {
    const index = this.formArray.value.indexOf(alternateId);
    if (index > -1) {
      this.formArray.removeAt(index);
      this.alternateIdRemoved.emit(alternateId);
      this.updateQueryParams();
    }
  }
} 